var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ciasteczka"},[_c('div',[_vm._v(" Ta witryna używa plików cookie w celu poprawnego jej działania. ")]),_c('div',{staticStyle:{"width":"20px"}}),_c('div',[_c('button',{staticClass:"btn btn-outline-light",attrs:{"type":"button"},on:{"click":function($event){return _vm.Klik()}}},[_vm._v("Rozumiem")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }